import { Component, OnInit } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { DataTaskService } from '@app/core/services/data-task.service';

@Component({
    selector: 'tt-p2-settings',
    templateUrl: './p2-settings.component.html',
    styleUrls: ['./p2-settings.component.css'],
})
export class P2SettingsComponent implements OnInit {
    public selectedSettingId: string = '';

    public filter: string = '';

    public settings: any[] = [];

    grid: GridOptions = new Grid().setLoadDataFunction({ method: 3751, parameters: () => ({ p2_setting_keyno: this.selectedSettingId }) });

    constructor(private datatask: DataTaskService) {}

    public async onSettingSubmitted(event: { p2_setting_keyno: string }) {
        await this.loadSettings();
        this.selectedSettingId = event.p2_setting_keyno;
        this.grid.gridfunc?.read();
    }

    private async loadSettings() {
        this.settings = await this.datatask.Post(6);
    }

    ngOnInit(): void {
        this.loadSettings();
    }
}
